import { useContext } from "react";
import { TokenContext } from "../context/TokenContext";
import useSWR from "swr";
import { environment } from "../config/environment";
import { swrFetcher } from "../services/queries";
import { UserModel } from "@attelas/shared";

export const useCurrentUser = () => {
  const { token } = useContext(TokenContext);

  const { data, isLoading, error } = useSWR<UserModel>(`${environment.apiUrl}/api/users/me`, (url: string) =>
    swrFetcher(url, { headers: { Authorization: `Bearer ${token}` } })
  );

  return {
    currentUser: data,
    isLoading,
    isError: !!error,
  };
};
